<template>
  <practitioner-layout v-if="render">
    <router-view @refresh=getData(true)></router-view>
      <grid
        v-if="showGrid"
        :headers-preset-type="headersPresetType"
        :headers-preset="headersPreset"
        :data="items"
        :loading="loading"
        @rowAdd="rowAdd"
        @refresh="getData"
        @rowClick="rowClicked"
        :disable-pagination="false"
        :hide-default-footer="loading"
        @grid-options-changed="gridOptionsChanged"
        :server-items-length="rowsNumber"
        @grid-search="gridSearch"
        :disable-sort="false"
        :hide-filters="true"
        :search-value.sync="filter.searchValue"
        :show-grid-settings="true"
      >
        <template v-slot:filters v-if="showFilters">
          <AppointmentGridFilters
            :filter-data="filterData"
            :specialities-list="specialitiesList"
            :categories-list="categoriesList"
            :patient-locations-list="filterData.patientLocations"
            :initial-filters="currentFilters"
            :show-practice-switch="showPracticeSwitch"
            :show-category-filter="false"
            :show-speciality-filter="true"
            :show-patient-location-filter="true"
            :loading="filtersLoading"
            @filters-changed="onFiltersChanged"
          />
        </template>
      </grid>
  </practitioner-layout>
</template>

<script>
import Grid from '@components/common/Grid.vue'
import PractitionerLayout from '@router/layouts/practitioner.vue'
import appointmentsPracticesHeaders from '@src/data/dataset/gridHeaders/appointmentPractices'
import AppointmentGridFilters from '@components/common/grid-elements/AppointmentGridFilters.vue'
import config from '@src/config'
import moment from 'moment'

export default {
  name: 'AppointmentGrid',
  components: {
    Grid,
    PractitionerLayout,
    AppointmentGridFilters
  },
  data () {
    return {
      items: [],
      loading: false,
      appStatusesLoading: false,
      alertStatusesLoading: false,
      alertTypesLoading: false,
      patientLocationsLoading: false,
      specialitiesLoading: false,
      headersPresetType:'appointmentPractices',
      headersPreset:appointmentsPracticesHeaders,
      render:true,
      gridOptions: {},
      rowsNumber: 0,
      gridSearchPhrase: '',
      restRequest: null,
      onlyCurrentPractice: true,
      filterData: {
        appointmentStatuses: [],
        alertStatuses: [],
        alertTypes: [],
        patientLocations: [],
      },
      filter: {
        searchValue: '',
        dateRange: null,
        patientLocationIds: [],
        alertStatuses: [],
        alertTypes: [],
        specialityIds: [],
      },
      specialitiesList: [],
      categoriesList: [],
      appointmentStatuses: [],
      getDataRequest: undefined,
      showGrid: false
    }
  },
  methods: {
    getAppointmentStatuses() {
      this.appStatusesLoading = true
      this.$_rest.get(`/practitioners/${this.$store.getters['app/currentUserId']}/appointment-statuses`, {
        isActive: 1
      }, response => {
        this.filterData.appointmentStatuses = response.data.filter(status => status.nameWeb).sort((a, b) => (a.nameWeb > b.nameWeb) ? 1 : -1)
        this.appStatusesLoading = false
      }, error => {
        console.error(error)
        this.$_notify.error('Failed to load appointment statuses')
        this.appStatusesLoading = false
      }, {
        prefixRoutesWithOrganizationId: false
      });
    },
    getAlertStatuses() {
      this.alertStatusesLoading = true
      this.$_rest.get(`/organizations/${this.$store.getters['app/currentOrganizationId']}/practitioners/${this.$store.getters['app/currentUserId']}/alert-statuses`, {},
       response => {
        // Include active items AND any currently selected items (even if inactive)
        const activeItems = response.data.filter(item => item.isActive)
        const selectedCodes = this.filter.alertStatuses || []
        const selectedInactiveItems = response.data.filter(item => 
          !item.isActive && selectedCodes.includes(item.code)
        )
        this.filterData.alertStatuses = [...activeItems, ...selectedInactiveItems]
        this.alertStatusesLoading = false
      }, error => {
        console.error(error)
        this.$_notify.error('Failed to load appointment statuses')
        this.alertStatusesLoading = false
      }, {
        prefixRoutesWithOrganizationId: false
      });
    },
    getAlertTypes() {
      this.alertTypesLoading = true
      this.$_rest.get(`/organizations/${this.$store.getters['app/currentOrganizationId']}/practitioners/${this.$store.getters['app/currentUserId']}/alert-types`, {},
       response => {
        // Include active items AND any currently selected items (even if inactive)
        const activeItems = response.data.filter(item => item.isActive)
        const selectedCodes = this.filter.alertTypes || []
        const selectedInactiveItems = response.data.filter(item => 
          !item.isActive && selectedCodes.includes(item.code)
        )
        this.filterData.alertTypes = [...activeItems, ...selectedInactiveItems]
        this.alertTypesLoading = false
      }, error => {
        console.error(error)
        this.$_notify.error('Failed to load alert types')
        this.alertTypesLoading = false
      }, {
        prefixRoutesWithOrganizationId: false
      });
    },
    getPatientLocations() {
      this.patientLocationsLoading = true
      this.$_rest.get(`/practitioners/${this.$store.getters['app/currentUserId']}/patient-locations`, {
        limit: 10000
      }, response => {
        // Include active items AND any currently selected items (even if inactive)
        const activeItems = response.data.filter(location => location.isActive)
        const selectedIds = this.filter.patientLocationIds || []
        const selectedInactiveItems = response.data.filter(location => 
          !location.isActive && selectedIds.includes(location.id)
        )
        this.filterData.patientLocations = [...activeItems, ...selectedInactiveItems]
        this.patientLocationsLoading = false
      }, error => {
        console.error(error)
        this.$_notify.error('Failed to load patient locations')
        this.patientLocationsLoading = false
      }, {
        prefixRoutesWithOrganizationId: true
      });
    },
    getData (resetPage = false) {
      if (!this.filter.dateRange) {
        this.$_notify.error(this.$_t('Date range must be selected'));
        return;
      }
      if (this.filter.dateRange.length === 1) {
        this.filter.dateRange.push(this.filter.dateRange[0])
      }
      if (resetPage) {
        this.gridOptions.page = 1
      }
      const url = this.onlyCurrentPractice ? `/practitioners/${this.$store.getters['app/currentUserId']}/datasets/appointments` :
        `/practitioners/${this.$store.getters['app/currentUserId']}/datasets/referred-appointments`
      this.items = []
      this.loading = true
      if (this.restRequest) {
        this.restRequest.abort();
        this.restRequest = null
      }
      if (this.getDataRequest) {
        this.getDataRequest.abort()
      }
      this.getDataRequest = this.restRequest = this.$_rest.get(url ,{
          // appointmentStatuses: this.appointmentStatuses || [],
          filter: this.gridFilter || {},
          sorting: {columns: this.gridOptions.sortBy, desc: this.gridOptions.sortDesc},
          limit: this.gridOptions.itemsPerPage || 50,
          offset: ((this.gridOptions.page || 1) - 1) * this.gridOptions.itemsPerPage
        }, response => {
          this.rowsNumber = response.meta.rowsNumber
          this.items = this.mapDatasetResponse(response)
          this.$store.dispatch('appointment/setAppointmentsList', this.items).then(() => {
            this.loading = false
          })
        }, error => {
          this.loading = false
          if (error.code !== this.$_rest.const.ABORT_ERROR) {
            this.$_notify.error(error)
          }
        })
    },
    rowAdd () {
    },
    rowClicked (row) {
      this.$store.commit('appointment/setAppointmentsList', this.items)
      this.$router.push({ name: 'appointment-details', params: { id: row.appointmentId } })
    },
    gridOptionsChanged(options) {
      this.gridOptions = options
      this.getData()
    },
    gridSearch(val) {
      this.gridSearchPhrase = val
      this.getData(true)
    },
    fetchAllSpecialities(){
      this.specialitiesLoading = true
      const practitionerId = this.$store.getters['app/practitioner'].id
      return new Promise((resolve, reject) => {
        this.$_rest.get(`/practitioners/${ practitionerId }/specialities`, {
          groups: ['all', 'practitioner_speciality', 'practitioner_all', 'practitioner_practice_default_speciality'].join(','),
          limit: 10000
        }, (response) => {
          this.specialitiesList = response.data ? response.data : []
          this.specialitiesLoading = false
          resolve(response)
        }, error => {
          this.specialitiesLoading = false
          reject(error)
        })})
    },
    cacheDateRange() {
      sessionStorage.setItem('gridDateRange', JSON.stringify(this.filter.dateRange))
    },
    initDateRange() {
      this.filter.dateRange = [
        moment().subtract(2, 'weeks').startOf('isoWeek').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ]
    },
    loadSavedFilters() {
      try {
        const savedData = localStorage.getItem('appointmentGridFilters')
        if (!savedData) {
          return
        }

        const parsedData = JSON.parse(savedData)
        if (parsedData && parsedData.filters) {
          // Load the saved filter values before fetching filter data
          // This ensures inactive items that are selected will be included
          this.appointmentStatuses = parsedData.filters.appointmentStatuses || []
          this.filter.alertStatuses = parsedData.filters.alertStatuses || []
          this.filter.alertTypes = parsedData.filters.alertTypes || []
          this.filter.patientLocationIds = parsedData.filters.patientLocationIds || []
          this.filter.specialityIds = parsedData.filters.specialityIds || []
          this.onlyCurrentPractice = parsedData.filters.onlyCurrentPractice ?? true
        }
      } catch (error) {
        console.error('Error loading saved filters:', error)
      }
    },
    onFiltersChanged(filters) {
      // Update local filter state
      this.filter.dateRange = filters.dateRange
      this.appointmentStatuses = filters.appointmentStatuses
      this.onlyCurrentPractice = filters.onlyCurrentPractice
      
      // Update other filter properties if they exist
      if (typeof filters.appointmentCategoryId !== 'undefined') {
        this.filter.appointmentCategoryId = filters.appointmentCategoryId
      }
      if (typeof filters.specialityIds !== 'undefined') {
        this.filter.specialityIds = filters.specialityIds
      }
      if (typeof filters.patientLocationIds !== 'undefined') {
        this.filter.patientLocationIds = filters.patientLocationIds
      }
      if (typeof filters.alertStatuses !== 'undefined') {
        this.filter.alertStatuses = filters.alertStatuses
      }
      if (typeof filters.alertTypes !== 'undefined') {
        this.filter.alertTypes = filters.alertTypes
      }
      // Trigger data refresh
      this.getData(true)
    },
  },
  computed:{
    refreshed() {
      return this.$store.getters['app/getRefreshed']
    },
    showPracticeSwitch(){
      return config.showPracticeSwitch
    },
    showFilters() {
      return !config.hideAppointmentGridFilters
    },
    currentFilters() {
      return {
        dateRange: this.filter.dateRange,
        appointmentStatuses: this.appointmentStatuses,
        alertStatuses: this.filter.alertStatuses,
        alertTypes: this.filter.alertTypes,
        onlyCurrentPractice: this.onlyCurrentPractice,
        appointmentCategoryId: this.filter.appointmentCategoryId || null,
        specialityIds: this.filter.specialityIds || [],
        priorityId: null,
        clinicId: null,
        practitionerId: null,
        patientLocationIds: this.filter.patientLocationIds || []
      }
    },
    gridFilter() {
      let filter = {}
      if(this.onlyCurrentPractice){
        filter = {
          practitionerPracticeId: this.$store.getters['app/practitionerPractice'].id,
        }
      } else {
        filter = {
          practitionerId: this.$store.getters['app/practitioner'].id,
        }
      }

      const searchableColumns = [
        'searchPatientFullName',
        'searchClinicNameShort',
        'searchProcedureName',
        'searchInsurerName',
        'searchClinicScanRoomCode',
        'searchPatientNumber1',
        'searchPatientIdShort',
        'searchPatientIdExternal',
        'searchAppointmentIdShort',
        'searchPatientLocationName'
      ];

      if (this.gridSearchPhrase) {
        searchableColumns.forEach((col) => {
          filter[col] = {
            type: 'like',
            x: this.gridSearchPhrase,
            connector: 'OR'
          }
        })
      }

      if (this.filter.dateRange && this.filter.dateRange.length === 2) {
        this.cacheDateRange()
        let range = this.filter.dateRange
        range = range.sort()
        filter['createdDateFrom'] = { type: 'gt', x: range[0]}
        //to date does not include apts of that day, even with lte type, add 1 day
        const toDate = new Date(range[1])
        toDate.setDate(toDate.getDate() + 1)
        filter['createdDateTo'] = { type: 'lte', x: moment(toDate).format('YYYY-MM-DD')}
      }

      if (this.filter.patientLocationIds && this.filter.patientLocationIds.length > 0) {
        filter['patientLocationId'] = {
          type: 'in',
          x: this.filter.patientLocationIds.join(',')
        }
      }
      if (this.filter.alertStatuses && this.filter.alertStatuses.length > 0) {
        filter['alertStatusCode'] = {
          type: 'in',
          x: this.filter.alertStatuses.join(',')
        }
      }
      if (this.filter.alertTypes && this.filter.alertTypes.length > 0) {
        filter['alertTypeCode'] = {
          type: 'in',
          x: this.filter.alertTypes.join(',')
        }
      }

       if (this.filter.specialityIds && this.filter.specialityIds.length > 0) {
        filter['appointmentSpecialityId'] = {
          type: 'in',
          x: this.filter.specialityIds.join(',')
        }
      }

      if(this.appointmentStatuses && this.appointmentStatuses.length) {
        filter['appointmentStatusCode'] = {
          type: 'in',
          x: this.appointmentStatuses.join(',')
        }
      }

      return filter
    },
    filtersLoading(){
      return this.appStatusesLoading || this.alertStatusesLoading || this.alertTypesLoading || this.patientLocationsLoading || this.specialitiesLoading
    }
  },
  watch:{
    refreshed(val) {
       if(val) {
        this.render = false
        this.$nextTick(()=>{
          this.render = true
          this.$store.commit('app/setRefreshed',false)
        })
      }
    },
    onlyCurrentPractice(){
      this.getData()
    }
  },
  mounted () {
    // Load saved filters from localStorage first
    this.loadSavedFilters()
    
    if (this.$store.getters['app/practitionerPractice']) {
      this.showGrid = true
      this.getAppointmentStatuses(),
      this.getAlertStatuses(),
      this.getAlertTypes(),
      this.getPatientLocations(),
      this.fetchAllSpecialities()
    }

    const gridDateRange = sessionStorage.getItem('gridDateRange')
    if (gridDateRange) {
      try {
        this.filter.dateRange = JSON.parse(gridDateRange)
      } catch (e) {
        this.initDateRange()
      }
    } else {
      this.initDateRange()
    }
  },
}
</script>
